module.exports = __webpack_public_path__ + "img/google.45163922.png";